import { createSlice } from '@reduxjs/toolkit';
import opticianApi from './opticianApi';

const dataSlice = createSlice({
    name: 'optician',
    initialState: {
        opticianList: [],
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            opticianApi.endpoints.opticianList.matchFulfilled,
            (state, action) => {
                state.opticianList = action.payload; // Save the new data to the state
            }
        );
    },
});

export default dataSlice.reducer;
